module.exports = __webpack_public_path__ + "img/logo_white.a9bb239d.svg";